import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class businesslitigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: ''
        };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {


        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }


        return (
            <div style={{ height: "100%",}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>




                                ​

                ​










            </div>
            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}

            <div>
                <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >


                    { lang==="en" &&  <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top",  maxHeight:"550px", minWidth:"20em", display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>Business Litigation</span><p/>
                        <span style={{fontSize: ".8em"}}>At the Morrow Firm, we are experienced in resolving all types of business disputes such as breach of contracts, partnership disputes, business torts, labor and employment, fraud, and California Unfair Competition Law. </span><p/>

                        <span style={{fontSize: ".8em"}}>Representative experience:</span><p/>
                        <ul><span style={{fontSize: ".8em"}}><li>Representing a prominent businesswoman in an $11 million breach of contract and fraud case.</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>Represented cancer immunotherapy company Juno Therapeutics in a breach of contract and patent infringement action against Novartis, which led to a $12 million settlement. See <a href="https://www.genengnews.com/topics/translational-medicine/novartis-to-pay-juno-12-25m-to-settle-car-patent-lawsuits/81251117/" target="_blank" rel="noopener noreferrer"> Genetic Engineering & Biotechnology News</a>, Novartis to Pay Juno $12.25M+ to Settle CAR Patent Lawsuits.</li></span><br/>
                    <span style={{fontSize: ".8em"}}><li>Represented Taco Bell against California Labor Code claims brought by a former employee.</li></span><br/></ul>

            </div>}

                    {lang==="zh" &&  <div style={{width: "50%", maxWidth:"50%", maxHeight:"550px", verticalAlign:"top", minWidth:"20em", display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>商业诉讼与纠纷</span><p/>
                        <span style={{fontSize: ".8em"}}>在沫若律师事务所，我们在解决各类型商业纠纷方面经验丰富，例如合同违约、合伙纠纷、商业侵权、劳工法、欺诈和加州反不正当竞争法。 </span><p/>

                        <span style={{fontSize: ".8em"}}>代表经验：</span><p/>
                        <ul><span style={{fontSize: ".8em"}}><li>代表一位成功的女商人处理1100万美元的合同违约和欺诈案件。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表癌症免疫治疗公司朱诺医疗（Juno Therapeutics）对诺华制药公司提起合同违约和专利侵权诉讼，最终获得1200万美元庭外和解。参见<a href="https://www.genengnews.com/topics/translational-medicine/novartis-to-pay-juno-12-25m-to-settle-car-patent-lawsuits/81251117/" target="_blank" rel="noopener noreferrer">基因工程和生物科技新闻</a>, Novartis to Pay Juno $12.25M+ to Settle CAR Patent Lawsuits。</li></span><br/>
                            <span style={{fontSize: ".8em"}}><li>代表塔可钟（Taco Bell）处理由前雇员提出的加利福尼亚州劳工法案下的索赔。</li></span><br/></ul>

                    </div>}
                    <div style={{width: "49%", maxWidth:"50%",   height:"100%", verticalAlign:"top",minWidth:"20em", display: "inline-block",  padding: "5px", top:"0px", }} ><img alt="Business Litigation<" style={{top:"0px", maxWidth:"450px", maxHeight:"550px",width: "100%"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/business.jpg?alt=media&token=ea6b44e0-f35e-4b71-86d8-e2215a87eeab"/>

                    </div>
                </div>
            </div>
            <SiteFoot lang={lang}/>
            </div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang };
}

export default connect(mapStateToProps, { getUser })(businesslitigation);



// WEBPACK FOOTER //
// ./src/Containers/businesslitigation.js